export const buildDivisionMap = divisions =>
  Object.fromEntries((divisions || []).map(division => [division.division_id, division.name]));

export const divisionNames = (divisionIds, divisionMap) =>
  (divisionIds || [])
    .map(divisionId => divisionMap?.[divisionId])
    .filter(name => name)
    .sort((a, b) => a.localeCompare(b));

export const formatDivisions = (divisionIds, divisionMap) => divisionNames(divisionIds, divisionMap).join(', ') || '-';
